import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Field, useFormikContext } from "formik";
import classnames from "classnames";
import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

const PhoneField = (props) => {
  const [focusedField, setFocusedField] = useState(false);
  const { isSubmitting, setFieldValue } = useFormikContext();

  const placeholderId = `fields.${props.name}`;

  return (
    <FormGroup className={classnames({ focused: focusedField })}>
      <InputGroup
        className={`input-group-merge input-group-alternative ${
          props.errorClass ? props.errorClass : ""
        }`}
      >
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <FontAwesomeIcon icon={faPhoneAlt} />
          </InputGroupText>
        </InputGroupAddon>
        <br />
        <FormattedMessage id={placeholderId}>
          {(placeholder) => (
            <Field
              name={props.name}
              placeholder={placeholder}
              onFocus={() => {
                if (props.focusEffect) setFocusedField(true);
              }}
              onBlur={(event) => {
                props.handleBlur(event);
                if (props.focusEffect) setFocusedField(false);
              }}
              className="form-control"
              onChange={(event) => {
                setFieldValue(event.target.value);

                if (props.onChange) props.onChange(event);
              }}
              disabled={isSubmitting}
            />
          )}
        </FormattedMessage>
      </InputGroup>
    </FormGroup>
  );
};
PhoneField.defaultProps = {
  name: "organization_phone",
  icon: "fas fa-phone-square-alt",
  autoComplete: "tel",
  focusEffect: true,
  errorClass: "",
};

export { PhoneField };
